import { render, staticRenderFns } from "./rating-scale.vue?vue&type=template&id=1a165824&scoped=true&"
import script from "./rating-scale.vue?vue&type=script&lang=js&"
export * from "./rating-scale.vue?vue&type=script&lang=js&"
import style0 from "./rating-scale.vue?vue&type=style&index=0&id=1a165824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a165824",
  null
  
)

export default component.exports